export class RatingSaveDTO {
  BIN: string;
  mark: number;
  comment: string;
  email: string;
}

export class RatingSavedId {
  id: number;
}
